import axios from 'axios';
import config from '../config';

// Create an instance of axios with default config
const api = axios.create({
  baseURL: config.apiUrl, // Use environment-specific API URL
  headers: {
    'Content-Type': 'application/json'
  },
  // Add timeout to prevent hanging requests
  timeout: 10000
});

// Add a request interceptor to attach auth token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  error => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add a response interceptor for handling errors
api.interceptors.response.use(
  response => response,
  error => {
    // Handle network errors
    if (!error.response) {
      console.error('Network Error:', error.message);
      // Return a structured error with a message the UI can use
      return Promise.reject({
        response: {
          data: {
            error: 'Network error. Please check your connection and try again.'
          },
          status: 0
        }
      });
    }
    
    // If token is expired, redirect to login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location = '/login';
    }
    
    // Log all API errors
    console.error('API Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data
    });
    
    return Promise.reject(error);
  }
);

// Fallback function for getting fake data when API is down in production
export const getFallbackData = (endpoint) => {
  // Simple fallback data for development and testing
  const fallbacks = {
    '/papers': { data: [], pagination: { page: 1, limit: 10, total: 0 }, total: 0 },
    '/auth/me': { data: null }
  };
  
  return fallbacks[endpoint] || { data: null };
};

export default api; 